<template>
  <div class="chain-container">
    <el-popover
      placement="bottom-start"
      trigger="hover"
      popper-class="referrer-info-popper"
    >
      <div class="referrer-info">
        <img
          class="avatar"
          :class="[type === 'Employee' && 'employee', alumni && 'alumni']"
          :src="[isCandidate ? $DjangoMediaUrl(photo) : photo]"
          @error.once="getDefaultProfilePhoto($event)"
          @click="openDetail"
        >
        <div class="info">
          <el-tooltip
            effect="light"
            placement="bottom"
            popper-class="light-tooltip-popper"
            :content="name"
          >
            <div v-if="name" class="name" :class="[!(isTheLastOne || type === 'Lead') && 'active']" @click="openDetail">{{ name }}</div>
          </el-tooltip>
          <el-tooltip
            effect="light"
            placement="bottom"
            popper-class="light-tooltip-popper"
            :content="getI18nPropertyValue(city, 'cn_name', 'name')"
          >
            <div v-if="city" class="location">{{ getI18nPropertyValue(city, 'cn_name', 'name') }}</div>
          </el-tooltip>
          <template v-if="type !== 'Lead' || isTheLastOne">
            <el-tooltip
            effect="light"
            placement="bottom"
            popper-class="light-tooltip-popper"
            :content="email"
          >
            <a v-if="email" class="email" :href="`mailTo:${email}`">{{ email }}</a>
          </el-tooltip>
            <div class="candidate-type">{{ candidateType }}</div>
          </template>
        </div>
      </div>
      <div class="avatar-container"  slot="reference">
        <img
          class="avatar"
          :class="[type === 'Employee' && 'employee', alumni && 'alumni']"
          :src="[isCandidate ? $DjangoMediaUrl(photo) : photo]"
          @error.once="getDefaultProfilePhoto($event)"
          @click="openDetail"
        >
      </div>
    </el-popover>
    <div v-if="!isTheLastOne" class="arrow-right">
      <span class="iconfont icona-hardlink"></span>
    </div>
  </div>
</template>

<script>
import { getI18nPropertyValue } from '@/i18n'

export default {
  props: {
    candidateId: {
      required: false
    },
    photo: {
      type: String
    },
    name: {
      type: String
    },
    email: {
      type: String
    },
    type: {
      type: String
    },
    isCandidate: {
      type: Boolean
    },
    city: {
      type: Object
    },
    isTheLastOne: {
      type: Boolean,
      default: false
    },
    inTalentPool: {
      type: Boolean,
      default: false
    },
    alumni: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      getI18nPropertyValue
    }
  },
  computed: {
    candidateType () {
      if (this.isTheLastOne && this.type !== 'Lead') {
        return this.$t('hm.resume.referralRoleType.prospect')
      } else if (this.isTheLastOne) {
        return this.$t('hm.resume.referralRoleType.lead')
      } else if (this.type === 'Employee') {
        return this.$t('hm.resume.referralRoleType.employee')
      }
      return this.$t('hm.resume.referralRoleType.candidate')
    }
  },
  created () {

  },
  methods: {
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    },
    openDetail () {
      if (this.isTheLastOne || !this.isCandidate || !this.inTalentPool) {
        return
      }
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/talent-pool/candidate/profile?candidate_id=${this.candidateId}&list_params={}&back=${backUrl}`)
    }
  }
}
</script>
<style lang='scss' scoped>
.chain-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .avatar-container {
    .avatar {
      width: 44px;
      height: 44px;
      padding: 1px;
      border: 1px solid transparent;
      border-radius: 50%;
      line-height: 1;
      cursor: pointer;

      // &.lead {
      //   border-color: #51bf82;
      // }

      &.employee {
        border-color: #0096cc;
      }

      // &.candidate {
      //   border-color: #0096cc;
      // }

      &.alumni {
        border-color: #ee7815;
      }
    }
  }

  .arrow-right {
    margin: 0 7px;

    > span {
      font-size: 40px;
      color: #0096cc;
    }
  }
}

.referrer-info-popper {
  background: #e6e6e6 !important;
  .referrer-info {
    display: flex;
    width: 220px;

    .avatar {
      width: 58px;
      height: 58px;
      border-radius: 50%;
      line-height: 1;

      &.employee {
        border-color: #0096cc;
      }

      &.alumni {
        border-color: #ee7815;
      }
    }

    .info {
      margin-left: 10px;

      div, a {
        font-size: 12px;
        height: 18px;
        line-height: 18px;
      }

      .name {
        color: #303133;
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.active {
          cursor: pointer;
        }
      }

      .email {
        color: #0096cc;
      }

      .email {
        width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }
    }
  }
  .popper__arrow {
    ::after {
      border-bottom-color: #e6e6e6 !important;
    }
  }
}
</style>

<style lang="scss">
.referrer-info-popper {
  background: #e6e6e6 !important;
  .popper__arrow {
    &::after {
      border-bottom-color: #e6e6e6 !important;
    }
  }
}
</style>
